import { createActionCreator } from '../../utils/helpers';
import { network, signupNetwork } from './types';

export const requestNetwork = createActionCreator(network.request, 'network');
export const requestNetworkSuccess = createActionCreator(network.success, 'response');
export const requestNetworkFailure = createActionCreator(network.failure, 'error');
export const requestSignupNetwork = createActionCreator(signupNetwork.request, 'payload');
export const requestSignupNetworkSuccess = createActionCreator(signupNetwork.success);
export const requestSignupNetworkFailure = createActionCreator(signupNetwork.failure, 'error');
